import { s3Templates } from '../actions';

const initialState = {
  templatesJSON: {
    templates: {},
    collections: []
  }
};

const s3Templates_reducers = (state = initialState, action) => {
  let newstate;
  switch (action.type) {
    case s3Templates.types.FETCHINGTEMPLATEJSON:
      newstate = {
        fetchTemplateJSON: action.type
      };
      return { ...state, ...newstate };
    case s3Templates.types.FETCHEDTEMPLATEJSON:
      newstate = {
        fetchTemplateJSON: action.type,
        templatesJSON: JSON.parse(action.data.Body.toString())
      };
      return { ...state, ...newstate };
    case s3Templates.types.FETCHTEMPLATEJSONFAILED:
      newstate = {
        fetchTemplateJSON: action.type
      };
      return { ...state, ...newstate };
    default:
      return state;
  }
};

export default s3Templates_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/s3Templates.js